
const RadioBox = function (props) {
	const optionKeys = Object.keys(props.options);
	var defaultValue = ( props.defaultValue === "true" || props.defaultValue === "false") ?
	  JSON.parse(props.defaultValue) 
	: props.defaultValue;

	return <div className="question radio-box">
		
		<label>{props.children}</label>
		{ optionKeys.map( (optionKey ,i)=>(
			<div key={i}>
				<label className="radio-container" htmlFor={props.name+i}>
					<input type="radio" 
						name={props.name} 
						id={props.name+i} 
						value={props.options[optionKey]}
						checked={ props.options[optionKey] === defaultValue }
						readOnly={true}
						onClick={(e) => ( props.handler(e.target.value , props.modelName) )}
						/>
					<span className="checkmark"></span>
					<span className="label">{optionKey}</span> 
				</label>

			</div>
			))}
	</div>
};

export  {RadioBox};